import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys, IInfoBlockItem } from "shared/types";

export const getInfoBlockItemKey = (bandId: string, type: IInfoBlockItem) => {
  switch (type) {
    default:
    case IInfoBlockItem.contact: {
      return `${API_ENDPOINTS.BAND(bandId)}/${IDataKeys.contact}`;
    }
    case IInfoBlockItem.place: {
      return `${API_ENDPOINTS.BAND(bandId)}/${IDataKeys.place}`;
    }
    case IInfoBlockItem.file: {
      return `${API_ENDPOINTS.BAND(bandId)}/${IDataKeys.file}`;
    }
    case IInfoBlockItem.image: {
      return `${API_ENDPOINTS.BAND(bandId)}/${IDataKeys.image}`;
    }
  }
};
